module.exports = __webpack_public_path__ + "static/media/ZIYUAN 1-02C (ZY 1-02C).e5e2cb86.czml";